import HSTooltipWithEllipsis from 'components/tooltipEllipsis'
import type { CheckboxProps } from 'flowbite-react'
import { Checkbox, Label } from 'flowbite-react'
import { forwardRef } from 'react'

interface HSCheckboxProperties extends CheckboxProps {
	label?: string
	helperText?: string
}

const HSCheckbox = forwardRef<HTMLInputElement, HSCheckboxProperties>(
	(
		properties: HSCheckboxProperties,
		reference: React.ForwardedRef<HTMLInputElement>
	) => {
		const { label = '', helperText = '', disabled, ...rest } = properties
		const theme = {
			root: {
				base: `h-4 w-4 rounded border border-gray-300 ${disabled ? 'bg-gray-200 cursor-not-allowed' : 'cursor-pointer'} `,
				color: {
					default:
						'text-primary-700 ring-0 focus:ring-transparent focus:outline-none focus:ring-offset-0 focus:ring-offset-transparent',
					primary:
						'text-primary-700 ring-0 focus:ring-transparent focus:outline-none focus:ring-offset-0 focus:ring-offset-transparent',
					gray: 'text-gray-400 ring-0 focus:ring-transparent focus:outline-none focus:ring-offset-0 focus:ring-offset-transparent'
				}
			}
		}

		return (
			<div
				className={`${label || helperText ? 'gap-2' : ''} flex items-center`}
			>
				<Checkbox
					{...rest}
					ref={reference}
					theme={theme}
					className='!focus:ring-0 !focus:outline:none'
					id={label || helperText}
					disabled={disabled}
				/>
				{label || helperText ? (
					<Label
						className={`flex text-sm font-normal leading-none ${disabled ? '!text-gray-500' : 'text-gray-700'}`}
						htmlFor={label || helperText}
					>
						<div className='flex flex-col'>
							<HSTooltipWithEllipsis content={label} />
							{helperText ? (
								<div className='text-xs text-gray-500'>{helperText}</div>
							) : null}
						</div>
					</Label>
				) : null}
			</div>
		)
	}
)

export default HSCheckbox
